export default __webpack_public_path__ + "static/media/propogation.df6411d2.gif";